module.exports = __webpack_public_path__ + "static/media/p4.c2aa17ae.svg";